module.exports = __webpack_public_path__ + "static/media/close.c1654bb7.svg";